import {Injectable} from '@angular/core';
import {environment} from '../../environments/environment';
import {HttpClient, HttpHeaders, HttpResponse} from "@angular/common/http";
import {Observable} from "rxjs";
import {User} from "../models/user.model";

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  constructor(private http: HttpClient,) {
  }

  getAutentication() {
    //const JwtToken: any = token;
    //console.log('token ==> ', token);
    return sessionStorage.getItem('session_token') || null;
  }

  getReqHeader() {
    let reqHeader = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + this.getAutentication()
    });
    console.log('reqHeader', reqHeader);
    return reqHeader;
  }

  // User
  login(_idrpps: string, _password: string) {
    let data = {id_rpps: _idrpps, password: _password}
    return this.http.post<any>(environment.login, data);
  }

  forgotPassword(_email: string) {
    return this.http.post<any>(environment.forgotPassword, {email: _email});
  }

  resetPassword(_token: string, _new_password: string,) {
    return this.http.patch<any>(environment.resetPassword, {token: _token, new_password: _new_password});
  }

  addUser(_user: User) {
    return this.http.post<any>(environment.addUser, _user, {headers: this.getReqHeader()});
  }

  editUser(_user: User) {
    return this.http.put<any>(environment.editUser, _user, {headers: this.getReqHeader()});
  }

  getUser() {
    return this.http.get(environment.getCurrentUser, {headers: this.getReqHeader()});
  }

  trackingConsent(trackingConsent: boolean) {
    return this.http.patch(`${environment.trackingConsent}?allowTracking=${trackingConsent}`, {}, {headers: this.getReqHeader()});
  }

  getModules(): Observable<any> {
    return this.http.get(environment.getModules, {headers: this.getReqHeader()});
  }

  getScore(_uuid: string): Observable<any> {
    return this.http.get(environment.getScore.replace('{uuid}', _uuid), {headers: this.getReqHeader()});
  }

  startModule(_uuid: string) {
    return this.http.patch(environment.startModule.replace('{uuid}', _uuid), {}, {headers: this.getReqHeader()});
  }

  finishModule(_uuid: string) {
    return this.http.patch(environment.finishModule.replace('{uuid}', _uuid), {}, {headers: this.getReqHeader()});
  }

  getQuestionByRef(_reference: string): Observable<any> {
    return this.http.get(environment.getQuestionByRef.replace('{reference}', _reference), {headers: this.getReqHeader()});
  }

  addAnswer(_answers: (number | null)[], _qstRef: string) {
    console.log("addAnswer", _answers, _qstRef);
    return this.http.post(environment.addAnswer.replace('{id}', _qstRef), {answer_ids : _answers}, {headers: this.getReqHeader()});
  }

  getQstRefLastAnswered(_uuid: string) {
    return this.http.get(environment.getLastRefQuestion.replace('{uuid}', _uuid), {headers: this.getReqHeader()});
  }

  downloadStats(): Observable<HttpResponse<Blob>> {
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + this.getAutentication(), // Si authentification nécessaire
    });

    return this.http.get<Blob>(environment.getStats, {
      headers: headers,
      responseType: 'blob' as 'json', // Type de la réponse Blob
      observe: 'response' // Observer la réponse complète pour récupérer les headers
    });
  }

  downloadUserStats(): Observable<HttpResponse<Blob>> {
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + this.getAutentication(),
    });

    return this.http.get(environment.getStatsUser, {
      headers: headers,
      responseType: 'blob',
      observe: 'response'
    });
  }
}
